<script lang="ts">
    export let large:boolean = false;

    import {familiesS} from '../stores';
    import Logo from '../components/logo.svelte';
</script>

<div class="logo-area" class:large="{large}">
    <Logo 
        color1={$familiesS.length > 0 ? [$familiesS[0].hue, $familiesS[0].saturation] : [0,0]} 
        color2={$familiesS.length > 1 ? [$familiesS[1].hue, $familiesS[1].saturation] : [0,0]} 
        color3={$familiesS.length > 2 ? [$familiesS[2].hue, $familiesS[2].saturation] : [0,0]} 
    />
</div>


<style>
    div {
        color: var(--text);
        background: none;
        border: none;
        transition: 0.3s;
        margin: 0;
        /* padding: 0.5rem 1rem; */
    }
    .logo-area.large > :global(*:first-child) {
        width: 128px;
        height: 128px;
    }
</style>